import { Stack, Typography, useTheme } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { RotatingLines } from 'react-loader-spinner';
import { makeStyles } from 'tss-react/mui';

interface Props {
  size?: 'small' | 'normal' | 'medium' | 'large';
  inline?: boolean;
  text?: string;
  gap?: number;
  textSize?: number;
}

const PaiSpinningLoader: React.FC<Props> = ({ size, inline, text, gap, textSize }) => {
  const { classes } = useStyles({ textSize });
  const theme = useTheme();

  const smallHeight = '19.5';
  const normalHeight = '32';
  const mediumHeight = '48';
  const largeHeight = '100';

  const height = _.isNil(size)
    ? normalHeight
    : size === 'small'
    ? smallHeight
    : size === 'normal'
    ? normalHeight
    : size === 'medium'
    ? mediumHeight
    : size === 'large'
    ? largeHeight
    : normalHeight;

  return (
    <div className={!inline ? classes.loader : undefined}>
      <Stack gap={!_.isNil(gap) ? gap : 2} justifyContent={'center'} alignItems={'center'}>
        <RotatingLines strokeColor={theme.palette.primary.main} strokeWidth={'3'} width={height} />
        {!_.isNil(text) ? <Typography className={classes.loadingText}>{text}</Typography> : null}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles<{ textSize?: number }>()((theme, { textSize }) => ({
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  loadingText: {
    fontSize: theme.typography.pxToRem(textSize || 12),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    textAlign: 'center',
  },
}));

export default PaiSpinningLoader;
